import clsx from "clsx";
import { Patient } from "core/types";
import { dp } from "ds_legacy/materials/metrics";
import { Button } from "ds/ui";
import { useCareseekerNavigationHandlers } from "dsl/hooks";
import { ArchivePatient } from "dsl/organisms/DeletePatientButton";
import { PatientIdentifier } from "dsl/organisms/PatientMenu/PatientIdentifier";
import { ChevronLeftIcon } from "lucide-react";
import { useEffect } from "react";
import { useTranslations } from "translations";

const PATIENT_CONSULTATION_MENU_HEIGHT_PX = 68;

export default function PatientConsultationMenu({
  patient,
  storybookPosition,
}: {
  patient: Patient;
  storybookPosition?: "static" | "fixed";
}) {
  const translations = useTranslations();
  const { goToDoctorDashboard } = useCareseekerNavigationHandlers();

  useEffect(() => {
    if (storybookPosition !== "static") {
      document.documentElement.style.setProperty(
        "--patient-menu-height",
        dp(PATIENT_CONSULTATION_MENU_HEIGHT_PX),
      );
    }
  }, [storybookPosition]);

  return (
    <>
      <div
        className={clsx(
          "top-navbar-height z-40 flex h-patient-menu w-screen items-center border-b border-gray-400 bg-white px-4",
          {
            fixed: storybookPosition !== "static",
            static: storybookPosition === "static",
          },
        )}
      >
        <div className="flex w-full items-center space-x-5">
          <Button
            color="primary"
            id="back-to-dashboard"
            size="sm"
            startContent={<ChevronLeftIcon size="16" />}
            variant="ghost"
            onPress={() => {
              goToDoctorDashboard();
            }}
          >
            {translations.actions.back}
          </Button>
          <PatientIdentifier patient={patient} />
          <ArchivePatient patient={patient} />
        </div>
      </div>
      {storybookPosition !== "static" && <div className="h-patient-menu" />}
    </>
  );
}
